<template>
  <v-container
    id="app-loyalty"
    class="pa-1"
  >
    <screen
      title="Montant de l'achat"
      :info="$amount()"
    />

    <v-card class="pa-2">
      <scrollable
        :sm="multiSelection"
        :md="!multiSelection"
      >
        <p
          v-if="multiSelection"
          class="bloc text-center caption"
        >
          {{ $t('field.loyalty.click_offer_multiple') }}
        </p>
        <div
          v-for="gift in giftList"
          :key="gift.IDCadeau"
          class="mb-3"
        >
          <custom-btn
            :title="gift.Libelle"
            :info="gift.DateFinValidite ? `Expire le ${$formatDate(gift.DateFinValidite)}` : ''"
            :color="ColorEnum.loyalty"
            @click="checkGift(gift)"
          >
            <v-simple-checkbox
              v-if="multiSelection"
              :value="gift.selected"
              disabled
              light
              @click="checkGift(gift)"
            />
          </custom-btn>
          <p
            v-if="!multiSelection"
            class="bloc text-center caption"
          >
            {{ $t('field.loyalty.click_offer') }}
          </p>
        </div>
      </scrollable>
    </v-card>

    <div
      v-if="multiSelection"
      class="mt-2 px-2"
    >
      <v-btn
        :disabled="multiGiftList.length === 0"
        color="green"
        block
        x-large
        @click="validGifts()"
      >
        Utiliser les bon<br>sélectionnés ({{ $amount(total) }})
      </v-btn>
      <v-btn
        :disabled="multiGiftList.length > 0"
        color="green"
        class="mt-5"
        block
        x-large
        @click="validGifts(true)"
      >
        {{ $t('field.loyalty.use_all_offers') }}<br>({{ $amount(max) }})
      </v-btn>
    </div>

    <div class="pull-bottom bloc pa-3">
      <v-btn
        color="red"
        block
        large
        @click="toTicket"
      >
        {{ $t('field.loyalty.not_use_offer') }}
      </v-btn>
    </div>

    <!-- **********************************
    ********** SAISIE PRIX MODAL **********
    *********************************** -->
    <keyboard-dialog
      v-model="showPrice"
      :max="$store.state.amount"
      :screen-title="$t('field.loyalty.amount_discount')"
      use-amount
      auto-close
      @close="currentGift = null"
      @valid="validAmount"
    />
  </v-container>
</template>

<script>
import { $amount, $formatDate } from '@/modules/Utils'
import { Scan } from '@/modules/Scan'
import { ColorEnum } from '@/modules/Enums'
import KeyboardDialog from '@/components/modal/KeyboardDialog'
import CustomBtn from '@/components/input/CustomBtn'

export default {
  name: 'LoyaltyGiftView',

  components: {
    CustomBtn,
    KeyboardDialog
  },

  props: {
    idBadge: { type: String, required: true },
    ticket: { type: Object, required: true },
    idAchat: { type: [String, Number], default: null },
    carrier: { type: Object, default: null },
    gifts: { type: Array, default: () => [] },
    multiSelection: { type: Boolean, default: false }
  },

  data () {
    return {
      ColorEnum,
      showPrice: false,
      currentGift: null,
      giftList: []
    }
  },

  computed: {
    amount () { return this.$store.state.amount },
    multiGiftList () {
      return this.giftList.filter(gift => gift.selected === true)
    },
    total () {
      let total = 0
      this.multiGiftList.forEach(gift => total += gift.Solde)
      return total
    },
    //
    maxGiftList () {
      let max = 0
      const gifts = []
      this.giftList.forEach(gift => {
        if ((max + gift.Solde) > this.amount) {
          return
        }
        max += gift.Solde
        gifts.push(gift)
      })
      return gifts
    },
    max () {
      let max = 0
      this.maxGiftList.forEach(gift => {
        max += gift.Solde
      })
      return max
    }
  },

  beforeMount () {
    if (!this.idBadge) {
      this.$router.replace('/')
    } else {
      this.$emit('title', this.$i18n.t('title.loyalty_offers'))
      this.gifts.forEach(gift => this.giftList.push({
        ...gift,
        IDCadeau: gift.IDCadeau.toString(),
        selected: false
      }))
    }
  },

  methods: {
    $amount,
    $formatDate,
    checkGift (gift) {
      if (this.multiSelection) {
        if (!gift.selected && (this.total + gift.Solde) > this.amount) {
          return
        }
        gift.selected = !gift.selected
      } else {
        if (gift.SaisieMontant) {
          this.currentGift = gift
          this.showPrice = true
        } else {
          this.useGift(gift.IDCadeau)
        }
      }
    },
    validAmount (amount) {
      this.useGift(this.currentGift.IDCadeau, amount)
    },
    useGift (idGift, amount = null) {
      Scan.launchFidConso(this.idBadge, this.idAchat, this.ticket, idGift, amount)
    },
    validGifts (all = false) {
      const giftList = []
      // On prend soit la liste des bons sélectionnés, soit la liste des max
      const gifts = all ? this.maxGiftList : this.multiGiftList
      // Création de la liste à envoyer à wsTPU
      gifts.forEach(gift => giftList.push({ IDCadeau: gift.IDCadeau }))

      Scan.launchFidConso(this.idBadge, this.idAchat, this.ticket, null, null, giftList)
    },
    toTicket () {
      this.$router.replace({
        name: 'ticket',
        params: {
          tickets: [this.ticket],
          carrier: this.carrier,
          floatingModeEnabled: this.$store.state.teleparameters.CashierEngagementMode === 'FLOATING'
        }
      })
    }
  }
}
</script>
